import { useEffect, useSyncExternalStore } from "react";
import { subscribe, getSnapshot, start, updateStatus } from "./presenceStore";

export const usePresence = () => {
    const state = useSyncExternalStore(subscribe, getSnapshot);

    useEffect(() => {
        start();
    }, []);

    return { ...state, updateStatus };
};
